import { CrudMode, Grid, ValidationErrors, useElementBreakpoints } from "@compass/core";
import { Permission, PermissionAction, Staff, StaffEditResource, StaffViewResource } from "generated/openApi";
import { StaffBasicInfo } from "./StaffBasicInfo";
import { isAuthorized } from "services";
import { Employments } from "./Employments";

export const StaffProfile = (props: {
  rootPermission: Permission;
  initialLoad: boolean;
  id: number;
  staff: Staff;
  setStaff: (value: Staff) => void;
  crudMode: CrudMode;
  viewResource: StaffViewResource;
  editResource: StaffEditResource;
  validationErrors: ValidationErrors;
  reroute: (id: number, crudMode: CrudMode) => void;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  return (
    <>
      <Grid ref={breakpointsRef} container spacing="md">
        <Grid item xs={setBreakpoints({ md: 8, xs: 12 })}>
          <Grid container spacing="md">
            <Grid item xs={setBreakpoints({ xs: 12 })}>
              <StaffBasicInfo
                staff={props.staff}
                setStaff={props.setStaff}
                crudMode={props.crudMode}
                viewResource={props.viewResource}
                editResource={props.editResource}
                validationErrors={props.validationErrors}
                reroute={props.reroute}
                hasEditButton
              />
            </Grid>

            {isAuthorized(Permission.StaffEmployment, PermissionAction.View) && (
              <Grid item xs={setBreakpoints({ xs: 12 })}>
                <Employments initialLoad={props.initialLoad} staffId={props.id} />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
